/**
 * @class directive_v3sMousewheel
 * @memberOf v3sWbtPlayerApp:helper
 * @description
 * Bindet eine function an den Mousewheel Event
 */

angular.module('v3sWbtPlayerApp').directive('v3sMousewheel', function () {
    return {
        restrict: 'A',
        scope:{
            onMousewheel : "&v3sMousewheel"
        },
        link: function (scope, element, attrs) {
            element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {

                var theHandler = scope.onMousewheel();
                // cross-browser wheel delta
                var event = window.event || event; // old IE support

                theHandler(event);
                // for IE
                event.returnValue = false;
                // for Chrome and Firefox
                if (event.preventDefault) event.preventDefault();
            });
        }
    }
});
